/// <summary>
/// This object provides js functions for ... <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 20.9.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 20.9.2022                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.FullHeatmap", $.bluaul.vcMenuTemplate, {
   
   
    _create: function () {
        var me = this;
        try {
            me.element.html("");
            me.options.invoke.vcvid = 342;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();
          
        } catch (e) { me.writeError('_create', e); return false;}
        return true;
    },





    _initVariables: function () {
        var me = this;
        try {
            me._super();
            me.settings.defaultChart = "heatmap";
            me.settings.menu.top.showMenuAsDropdown = false;
            me.settings.menu.top.interval.intervals = [3, 5];
            me.settings.menu.top.interval.default = 3; //we start with months
            me.settings.toggleView = true;
            me.settings.showSignalsInContent = true;
            me.settings.signalSelection = true;
            me.settings.showAllSignalsAtStart = true;
            me.settings.enableFilterForInvalidSignals = true;
            me.settings.hideSignalsWithNotAllowedSettings = true;
            me.settings.showArchiveRules = false;
            me.settings.enableMeta = false;

            me.settings.menu.top.showHeaders = true;
            me.settings.menu.top.interval.enabled = true;
            me.settings.menu.top.datatype.enabled = false;
            me.settings.menu.top.charts.enabled = false;
            me.settings.menu.top.opt.enabled = false;
            me.settings.menu.top.opt.showInterventions = false;
            me.settings.menu.top.opt.showTickets = false;

            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.showTakeBtnOnly = false;
            me.settings.menu.main.date.enabled = true;
            me.settings.menu.main.dateComparison.enabled = false;
            me.settings.menu.main.rampResolution.enabled = false;
            me.settings.menu.main.rampOptions.enabled = false;
            me.settings.menu.main.rampTempCharts.enabled = false;
            me.settings.menu.main.specificOptions.enabled = true;
            me.settings.menu.main.history.enabled = true;

            me.settings.menu.top.opt.showTags = false;
            me.settings.menu.top.opt.showRules = false;
            me.settings.menu.top.export.enabled = true;
            me.settings.menu.top.export.showFavorites = false;
            me.settings.menu.top.export.showShare = true;
            me.settings.selection.choice.enabled = true;
            me.settings.selection.entries.button.enabled = false;
            me.settings.selection.entries.signals.showIcons = false;

            me.settings.subvisual.content.signalSelection = true;



        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },




    _addAdditionalChartsToSettings: function () {
        var me = this;
        try {

            me._super();

            $.each(me.settings.charts, function () { this.enabled = false });
            me.settings.charts.filter(function (item) { return item.id == "heatmap" })[0].enabled = true;
            $.each(me.settings.iconCharts, function () { this.enabled = false });

        } catch (e) {
            me.writeError('_addAdditionalChartsToSettings', e);
            return false;
        }
        return true;
    },


    _fillSubvisualStructure: function () {
        /// <summary>
        /// we build up the structure 
        /// </summary>
        var me = this;
        try {
            let obj = null;
          
            obj = me.vcMenu.menu.main.specificOptions;
            var ddlHeatmap = $("<select>").attr("id", "specific-option-settings").addClass("ddl").css("width", "100%");
            ddlHeatmap.append($("<option>").val("1").text(me.specific.resources.archive));
            ddlHeatmap.append($("<option>").val("2").text(me.specific.resources.archiveWithoutOutlier));
            ddlHeatmap.append($("<option>").val("3").text(me.specific.resources.differential));
            obj.vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.dataResolution, clickable: true, isList: true, content: ddlHeatmap }]
            });
          

        } catch (e) { me._writeErr(e); }
    },


    _loadSubvisualContent: function (contentStatus) {
        var me = this;
        if (!me.error) { me._initSubvisualContent(contentStatus); }
    },


    _loadSubvisualFromChoiceList: function (status) {
        var me = this;
        try {

            if (!me.error) {



                //send the config for the share url
                var param = { bsaid: status.subvisual.selectedBsaid, startDate: status.menu.startDate, endDate: status.menu.endDate, DataType: parseInt(me.vcMenu.menu.main.specificOptions.find("#specific-option-settings").val()), LoggerId: me.specific.LoggerId, isStandAlone: false };

                status.signals.shareParameter = {
                    'info': { bsaid: status.subvisual.selectedBsaid, name: '', description: '', startDate: status.menu.startDate, endDate: status.menu.endDate, dateUserDef: status.date.isSingle == false, interval: status.menu.interval },
                    'visualname': "HEATMAP", "vcvid": 303, 'parameter': JSON.stringify(param), 'signalparameter': ""
                };

                me.vcMenu.subvisual.content.Heatmap({ invokeType: "addVisualBase", parameter: param, deviceType: me.settings.deviceType });
            }

        } catch (e) { me._writeErr(e); }


    },

});

